"use strict";
var NS = {};
document.addEventListener('DOMContentLoaded', function () {
    var hasSupportDocument = document.querySelector('.js-supportDocument');
    if (!hasSupportDocument)
        return;
    NS.print = function (url, title) {
        var sanitizedTitle = title.replace(/\s+/g, '');
        var win = window.open(url, sanitizedTitle);
        win.addEventListener('load', function () {
            win.print();
        });
    };
    var toggleSummary = function (element) {
        var summaryElement = element.closest('.supportDocument');
        var summary = summaryElement.querySelector('.supportDocument__summary');
        summaryElement.classList.toggle('is-open');
        summary.classList.toggle('is-open');
    };
    var openPrint = function (event) {
        event.preventDefault();
        var anchor = event.target.closest('a');
        var href = anchor.getAttribute('href');
        var title = anchor.querySelector('.supportDocument__title').textContent;
        NS.print(href, title);
    };
    document.querySelectorAll('.js-supportDocument a .print').forEach(function (printAnchor) {
        printAnchor.addEventListener('click', openPrint);
        printAnchor.addEventListener('keydown', function (event) {
            if (event.key === 'Enter')
                openPrint(event);
        });
    });
    document.querySelectorAll('.js-supportDocument a .button:not(.print)').forEach(function (button) {
        button.addEventListener('keydown', function (event) {
            if (event.key === 'Enter') {
                var href = button.closest('a').getAttribute('href');
                window.open(href, '_blank');
            }
        });
    });
    document.querySelectorAll('.multi-version .js-supportDocument a').forEach(function (anchor) {
        anchor.addEventListener('click', function (event) {
            var target = event.target;
            if (!target.classList.contains('js-external-link')) {
                event.preventDefault();
                var summaryTarget = target.classList.contains('summary') ? target : target.closest('.supportDocument').querySelector('.summary');
                toggleSummary(summaryTarget);
            }
        });
    });
});
